import styled from 'styled-components'

export default styled.h2`
font-size: 16px;
padding: 14px 0;
margin: 0;
line-height: normal;
text-align: center;
`
